var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6261 3.26532L11.3263 3.73673C10.8222 3.80875 10.4103 4.04904 10.1162 4.38114L2.41674 12.0806C1.6357 12.8616 1.63566 14.1279 2.41674 14.909L5.24517 17.7374C6.02625 18.5185 7.29255 18.5185 8.0736 17.7374L15.773 10.038C16.1051 9.74388 16.3454 9.33199 16.4174 8.82786L16.8888 5.52803C17.0775 4.20815 15.946 3.07671 14.6261 3.26532ZM12.3162 7.83793C12.7067 8.22843 13.3399 8.22846 13.7305 7.83793C14.121 7.4474 14.1209 6.81421 13.7305 6.42371C13.34 6.03322 12.7068 6.03319 12.3162 6.42372C11.9257 6.81424 11.9257 7.44743 12.3162 7.83793Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.a980e652473ed0418c2f73d9d2d4d50a.svg";
export { ForwardRef as ReactComponent };